import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

import { convertAreaLabel } from '~/models/area'

/**
 * 「対象なし」を表す em dash (対象が無いことを示す記号、i18n しない)。
 * ページ固有 model の `~/pages/WorkflowCases/models/workflowCase.ts` の
 * `WORKFLOW_CASE_NO_VALUE_LABEL` はこの定数を re-export するので、表記規約の
 * SoT はここ 1 箇所 (手動同期が不要)。
 */
export const NO_VALUE_LABEL = '—'

/**
 * エリア表示ラベル。BG 不要ケースは `areaCode` が UNSPECIFIED (=
 * `convertAreaLabel` が空文字を返す) になる (issue #5219: エリアは BG から
 * 導出される派生属性で、BG なしケースはエリアを持たない)。空欄でなく
 * 「—」を出す (対象なしセルと同じ表記)。
 *
 * CaseTable のエリア列 / CaseHeader (WorkflowCaseDetail) のエリア軸 /
 * DeleteCaseDialog のエリア欄の 3 箇所で共通の写像として使う。複数 page
 * (WorkflowCases / WorkflowCaseDetail) + shared component
 * (DeleteCaseDialog) から使われるため `~/pages/WorkflowCases/models/
 * workflowCase.ts` から昇格した (frontend/apps/ebalance/CLAUDE.md「複数pageで
 * 実際に使われてから共有directoryへ昇格する」、issue #5219 review 指摘)。
 */
export function areaLabelOrDash(areaCode: AreaCode): string {
  const label = convertAreaLabel(areaCode)
  return label === '' ? NO_VALUE_LABEL : label
}
